module.exports = __webpack_public_path__ + "static/media/copy-img.3e5177ce.svg";